export default __webpack_public_path__ + "static/media/budgeting-planning.75931dbb.png";